<template>
    <fragment>
        <BrandForm @cancel="cancel" @save="saveEditBrand" :parent-loading="loading" :type="FORM_TYPE.edit" v-if="brand" :brand="brand"> </BrandForm>
        <loader v-else-if="loading" :loading="true"> </loader>
    </fragment>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import brandService from "@/services/brand";
import TryLoadMixin from "@/mixins/TryLoadMixin";
import BrandForm from "@/components/admin/brand/BrandForm";
import ModalBase from "@/components/modal/ModalBase";
import loader from "@/components/loader/loader";
import { FORM_TYPE, unserializeBrand, serializeBrand } from "@/components/admin/brand/utils/brandFormUtils";
import cacheService from "@/services/cache";

export default {
    data() {
        return {
            FORM_TYPE,
            brand: undefined
        };
    },
    mixins: [TryLoadMixin],
    components: {
        BrandForm,
        ModalBase,
        loader
    },
    methods: {
        ...mapActions("functionality", {
            findAllApplications: "findAllApplications"
        }),
        ...mapActions({
            setTheme: "brand/setTheme"
        }),
        ...mapActions("currentUser", { updateCurrentBrand: "updateCurrentBrand" }),
        cancel() {
            this.$emit("hideEditBrand");
        },
        async saveEditBrand(brand) {
            const brandSerialized = await serializeBrand(brand);
            this.tryLoad(async () => {
                const res = await brandService.updateBrand(brandSerialized);
                if (this.brand.id === cacheService.getCurrentBrandId()) {
                    this.updateCurrentBrand(res);
                    this.setTheme(res.theme);
                }
                this.dialogSuccess(this.$trad.brand.successUpdateTxt);
                this.cancel();
            });
        }
    },
    computed: {
        ...mapGetters({
            getBrand: "items/getBrand"
        })
    },
    async created() {
        const response = await this.tryLoad(() => brandService.getBrand(this.getBrand.id));
        // Handle both array response and paginated {data: [...]} response
        const brandData = Array.isArray(response) ? response[0] : response.data ? response.data[0] : response;
        this.brand = unserializeBrand(brandData);
    }
};
</script>



// WEBPACK FOOTER //
// EditBrand.vue?143e12d6